import moment from 'moment'
import { extendMoment } from 'moment-range'
const momentExt = extendMoment(moment)

const CZ_HOLIDAYS = {
    '1.1': ['Den obnovy samostatného českého státu', 'Nový rok'],
    '10.4': ['Velký pátek'],
    '13.4': ['Velikonoční pondělí'],
    '1.5': ['Svátek práce'],
    '8.5': ['Den vítězství'],
    '5.7': ['Den slovanských věrozvěstů Cyrila a Metoděje'],
    '6.7': ['Den upálení mistra Jana Husa'],
    '28.9': ['Den české státnosti'],
    '28.10': ['Den vzniku samostatného československého státu'],
    '17.11': ['Den boje za svobodu a demokracii'],
    '24.12': ['Štědrý den'],
    '25.12': ['1. svátek vánoční'],
    '26.12': ['2. svátek vánoční'],
}

const getHoliday = function(d) {
    const day = d.get('date')
    const month = d.get('month') + 1
    return CZ_HOLIDAYS[`${day}.${month}`]
}

const isWeekend = function(d) {
    if (d.isoWeekday() === 6 || d.isoWeekday() === 7) {
        return true
    }
    return false
}

momentExt.fn.isHoliday = function() {
    return getHoliday(this) !== undefined
}

momentExt.fn.isWeekend = function() {
    return isWeekend(this)
}

momentExt.fn.getHoliday = function() {
    return getHoliday(this)
}

export default momentExt
